module.exports = __webpack_public_path__ + "img/7b7d742229418f139d88dede691be119.png";